export default __webpack_public_path__ + "media/zurb/img/case-study-iqtell/iqtell-img2-3ad7aa0a6c5fab4ffeea0d05aa5c0898.jpg";